import React, { useState } from "react";
import { Alert, Button, Form } from "react-bootstrap";

import imgEigenVerknupfung from "./img/eigverkn.webp";
import imgCloseTab from "./img/tabClose.png";
import { useConfig } from "./ConfigContext";

export default function Initialisierung({
   sharepointFoldername,
   activeAccount,
   initializeObject,
   data,
   saveSharepoint,
   changeData,
   loading,
}) {
   const config = useConfig();
   const [showSave, setShowSave] = useState(false);
   const [isTabClosed, setIsTabClosed] = useState(false);

   return (
      <>
         {!data.Name ? (
            <Alert variant="danger">
               <h3>Eigentümer hat keinen Namen oder fehlt!</h3>
               <p>
                  Falls ein Eigentümer verknüpft ist, bitte einen Namen eintragen. <br />
                  Ansonsten bitte Verknüpfung der Immobilie mit dem Eigentümer im oO hinzufügen und dann neu laden.
                  <strong>
                     (Immobilie {">"} Grunddaten {">"} Eigentümer)
                  </strong>
               </p>
               <img src={imgEigenVerknupfung} alt="" style={{ borderRadius: "6px" }} />
            </Alert>
         ) : (
            <>
               {!isTabClosed ? (
                  <Alert variant="danger">
                     <h3>onOffice Tab geschlossen?</h3>

                     <p>
                        <strong>
                           {" "}
                           Zum Schutz gegen versehentliches Überschreiben bitte den onOffice-Tab dieser Immobilie
                           schließen.
                        </strong>{" "}
                        <br /> <small>(Andere onOffice Tabs können offen bleiben.)</small>
                     </p>

                     <img
                        src={imgCloseTab}
                        alt=""
                        style={{ marginBottom: "12px", borderRadius: "0px", boxShadow: "0 0 10px 4px #333" }}
                     />
                     <p>Danach einfach bestätigen und wie gewohnt fortfahren.</p>
                     <div className="">
                        <Button variant="danger" style={{}} onClick={() => setIsTabClosed(true)}>
                           Ja, ich habe den Tab geschlossen
                        </Button>
                     </div>
                  </Alert>
               ) : (
                  <div className="initialisierung">
                     <h3>Zum Start die Auftragsart auswählen und dann die Immobilie initialisieren</h3>
                     {showSave && (
                        <Alert variant="success">
                           <ul className="m-0" style={{ listStyleType: "none" }}>
                              {config?.ms365?.active && (
                                 <li>
                                    <span className="animate-icon" style={{ animationDelay: "0s" }}>
                                       ✅
                                    </span>{" "}
                                    Sharepoint-Ordner <strong>{data.objektnr_extern + "_" + data.Name}</strong> wurde
                                    erstellt
                                 </li>
                              )}
                              <li>
                                 <span className="animate-icon" style={{ animationDelay: "1s" }}>
                                    ✅
                                 </span>{" "}
                                 Kacheln wurden geladen
                              </li>
                              {/* <li><span className="animate-icon" style={{animationDelay: "2s"}} >✅</span> Verkaufsstatus wurde gesetzt</li> */}
                           </ul>
                        </Alert>
                     )}
                     {data && (
                        <>
                           {!showSave ? (
                              <>
                                 <div>
                                    <select
                                       onChange={(e) => changeData(e.target.name, e.target.value, "init")}
                                       // value={data.dbin_a_o_b}
                                       className="form-select"
                                       style={{ width: "500px" }}
                                       name="dbin_a_o_b"
                                       id="dbin_a_o_b"
                                    >
                                       <option value=""></option>
                                       <option value="Bewertung">Bewertung</option>
                                       {config.company === "baur" && <option value="Auftrag">Auftrag</option>}
                                    </select>
                                 </div>

                                 <Button
                                    className="py-2 mt-2"
                                    disabled={!data.dbin_a_o_b || loading}
                                    style={{ width: "500px" }}
                                    onClick={async () => {
                                       console.log(data);
                                       initializeObject(activeAccount ? "sharepoint" : "").then((resp) =>
                                          setShowSave(resp),
                                       );
                                    }}
                                 >
                                    <strong>{data.objektnr_extern + "_" + data.Name}</strong> Initialisieren
                                 </Button>
                              </>
                           ) : (
                              <Button onClick={() => saveSharepoint()}>weiter</Button>
                           )}
                        </>
                     )}
                  </div>
               )}
            </>
         )}
      </>
   );
}
